<template>
  <div class="scroll-x-items">
    <div
      v-for="(item, index) in breadcrumb"
      :key="index"
      class="scroll-x-items__item ml-1"
    >
      <TagLink
        v-bind="item.tagLinkProps"
      >
        <span class="flex items-center">
          <span
            class="whitespace-nowrap inline-block text__sub--3 lg:text__sub--2"
            :class="[index !== breadcrumb.length - 1 ? 'text-blue-primary' : 'text-gray-disabled']"
          >
            {{ item.anchor }}
          </span>
          <AppIcon
            v-if="index !== breadcrumb.length - 1"
            color="text-gray-disabled"
            name="chevron-left"
          />
        </span>
      </TagLink>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Breadcrumb',
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style>

</style>
